import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL as string;

export const obtenerPaises = async () => {
  try {
    const response = await axios.get(`${API_URL}/paises`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los países:", error);
    throw error;
  }
};
